
<template>
  <Layout>
    <b-modal
        id="frmModel"
        scrollable
        title="Expedientes"
        title-class="font-24"
        size="xl"
        hide-footer
    >
      <b-overlay :show="isLoadingModal" rounded="sm">

        <b-tabs card  v-model="tab_activo">
          <b-tab title="Datos" active>
            <form class="needs-validation" @submit.prevent="submitModel">
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Descripción</label>
                  <input
                      class="form-control"
                      v-model="model.descripcion"
                      :class="{ 'is-invalid': submittedModel && $v.model.descripcion.$error }"
                      :disabled="deshabilitar_formulario"
                  />
                  <div v-if="submittedModel && $v.model.descripcion.$error" class="invalid-feedback">
                    <span v-if="!$v.model.descripcion.required">Este valor es requerido.</span>
                  </div>
                </div>
              </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <button class="btn btn-primary mr-2" type="submit"
                >
                  <i class="fa fa-save"></i>
                  Guardar</button>
                <button class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="cerrarFormulario"
                >
                  <i class="fa fa-door-closed"></i>
                  Salir</button>
              </div>
            </div>
        </form>
        </b-tab>
        <b-tab title="Clasificadores" >
          <div class="row">
            <div class="form-group col-md-9">
              <label>Clasificador</label>
              <v-select
                  :options="clasificadores"
                  label="nombre"
                  :reduce="desc=>desc.id"
                  v-model="clasificador_actual.clasificador_id"
              />
            </div>
            <div class="form-group col-md-3">
              <button class="btn btn-primary mt-4" type="button" v-on:click="agregarClasificador">Agregar</button>
            </div>
          </div>

          <table class="table table-bordered">
            <thead>
            <tr>
              <th>ID</th>
              <th>Clasificador</th>
              <th>Nombre</th>
              <th>Op</th>
            </tr>
            </thead>
            <tbody >
              <tr v-for="(data,index) in model.clasificadores"  v-bind:key="index">
                <td>{{data.id}}</td>
                <td>{{data.clasificador}}</td>
                <td>{{data.nombre}}</td>
                <td>
                  <button
                      v-show="$can('expediente-modificar')"
                      class="btn btn-danger btn-icon btn-sm ml-1"
                      v-on:click="borrarClasificador(data.id)" >
                    <i class="fa fa-trash"></i>
                  </button>

                </td>

              </tr>

            </tbody>


          </table>

        </b-tab>
          <b-tab title="Metas" >
            <div class="row">
              <div class="form-group col-md-6">
                <label>Metas</label>
                <input class="form-control" v-model="meta_actual.meta">
              </div>
              <div class="form-group col-md-2">
                <label>Año</label>
                <input class="form-control" v-model="meta_actual.anio">
              </div>
              <div class="form-group col-md-3">
                <button class="btn btn-primary mt-4" type="button" v-on:click="agregarMeta">Agregar</button>
              </div>
            </div>

            <table class="table table-bordered">
              <thead>
              <tr>
                <th>ID</th>
                <th>Meta</th>
                <th>Anio</th>
                <th>Op</th>
              </tr>
              </thead>
              <tbody >
              <tr v-for="(data,index) in model.metas"  v-bind:key="index">
                <td>{{data.id}}</td>
                <td><h4>{{data.meta}}</h4></td>
                <td><h4>{{data.anio}}</h4></td>
                <td>
                  <button
                      v-show="$can('expediente-modificar')"
                      class="btn btn-danger btn-icon btn-sm ml-1"
                      v-on:click="borrarMeta(data.id)" >
                    <i class="fa fa-trash"></i>
                  </button>

                </td>

              </tr>

              </tbody>


            </table>

          </b-tab>
        </b-tabs>


      </b-overlay>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex">
      <div>
        <button  type="button"
                 class="btn btn-primary mb-3"
                 v-on:click="nuevo"
                 v-show="$can('clasificadores-agregar')"
        >Nuevo</button>
      </div>
      <div class="ml-auto">

      </div>

    </div>

    <vue-good-table
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
              enabled: true,
              }"
        :rows="rows"
        :columns="columns"
        :globalSearch="true"
        styleClass="vgt-table striped smalltable"
    >
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
              <!--<button class="btn btn-success btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('clasificadores-ver')"
              ><i class="fa fa-eye"></i></button>-->
              <button class="btn btn-primary btn-icon btn-sm"
                      v-on:click="modificar(props.row.id)"
                      v-show="$can('clasificadores-modificar')"
              ><i class="fa fa-edit"></i></button>
              <!--<button class="btn btn-danger btn-icon btn-sm ml-1"
                      v-on:click="borrar(props.row.id)"
                      v-show="$can('clasificadores-eliminar')"
              ><i class="fa fa-trash"></i></button>-->
            </span>
        <span v-else>
              {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {/*decimal,*/required} from "vuelidate/lib/validators";
//import subirArchivos from "@/components/subir-archivos.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Clasificadores",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
//    subirArchivos,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Administración",
      items: [
        {
          text: "Finanzas",
          href: "/",
        },
        {
          text: "Clasificadores",
          active: true,
        },
      ],

      isLoading: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Descripción',
          field: 'descripcion',
        },

        {
          label: 'Acciones',
          field: 'acciones',
          width:'20%'
        },

      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage:10
      },
      isLoadingModal:false,
      deshabilitar_formulario:false,

      submittedModel:false,
      model:{
        id:0,
      },
      server:process.env.VUE_APP_BACKEND,
      tab_activo:0,
      clasificadores:[],
      clasificador_actual:{

      },
      meta_actual:{

      }
    };
  },


  computed:{
  },

  methods: {
    agregarMeta(){
      this.isLoadingModal=true;
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/expediente/meta",
          {
            'expediente_id':this.model.id,
            'meta':this.meta_actual.meta,
            'anio':this.meta_actual.anio,
          })
          .then(()=>{
            //this.model=response.data;
            //this.$bvModal.show("frmModel");
            this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    borrarMeta(id){
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {

          this.isLoadingModal=true;
          this.axios.delete(process.env.VUE_APP_BACKEND + "/api/expediente/meta",{
                data:  {
                  'expediente_id':this.model.id,
                  'meta_id':id
                }
              }
          )
              .then(()=>{
                //this.model=response.data;
                //this.$bvModal.show("frmModel");
                this.actualizar();
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error",'warning');
              })
              .finally(()=>this.isLoadingModal=false)
        }
      })


    },
    actualizar(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expediente/"+this.model.id)
          .then((response)=>{
            this.model=response.data;
            //this.$bvModal.show("frmModel");
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    agregarClasificador(){
      //expediente/clasificador
      this.isLoadingModal=true;
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/expediente/clasificador",
          {
            'expediente_id':this.model.id,
            'clasificador_id':this.clasificador_actual.clasificador_id
        })
          .then(()=>{
            //this.model=response.data;
            //this.$bvModal.show("frmModel");
            this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    borrarClasificador(id){


      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {

          this.isLoadingModal=true;
          this.axios.delete(process.env.VUE_APP_BACKEND + "/api/expediente/clasificador",{
                data:  {
                  'expediente_id':this.model.id,
                  'clasificador_id':id
                }
              }
          )
              .then(()=>{
                //this.model=response.data;
                //this.$bvModal.show("frmModel");
                this.actualizar();
              })
              .catch(()=>{
                this.$swal('Cuidado',"Error",'warning');
              })
              .finally(()=>this.isLoadingModal=false)
        }
      })


    },
    cerrarFormulario(){
      this.$bvModal.hide("frmModel");
    },
    submitModel(){
      this.submittedModel = true;
      // stop here if form is invalid
      this.$v.$touch();
      this.$v.model.$touch();
      if(this.$v.model.$error===false){
        this.guardar();
      }
      else
      {
        //console.log(this.$v);
        //console.log(this.model);
        this.$swal('Cuidado',"Formulario no valido",'warning');
        //alert("Formulario no valido")
      }
    },
    nuevo(){
      this.deshabilitar_formulario=false;
      this.submittedModel=false;
      this.model={
        id:0,
        descripcion:"",
      };
      this.$bvModal.show("frmModel");

    },
    modificar(id){
      this.deshabilitar_formulario=false;
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expediente/"+id)
          .then((response)=>{
            this.model=response.data;
            this.$bvModal.show("frmModel");
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)

    },
    guardar(){
      this.isLoadingModal = true;
      const request = this.model.id != 0
          ? this.axios.put(`${process.env.VUE_APP_BACKEND}/api/expediente/${this.model.id}`, this.model)
          : this.axios.post(`${process.env.VUE_APP_BACKEND}/api/expediente`, this.model);

      request
          .then(() => {
            this.$bvModal.hide("frmModel");
            this.loadItems();
          })
          .catch((error) => {
            if (error.response) {
              this.$swal('Cuidado',error.response.data.mensaje,'warning');
            }
            else
            {
              this.$swal('Error',"Server error",'error');
            }
          })
          .finally(() => {
            this.isLoadingModal = false;
          });

    },
    borrar(id) {
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.axios.delete(process.env.VUE_APP_BACKEND + '/api/expediente/' + id)
              .catch((error) => {
                if (error.response) {
                  this.$swal('Cuidado!',error.response.data.mensaje,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(
                  () => {
                    this.isLoading = false;
                    this.loadItems();
                  }
              );
        }
      })

    },

    say: function (message) {
      alert(message)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [{
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        }],
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/expediente/tabla', {'params': this.serverParams})
          .then((response) => {
            //console.log(response.data.data);
            this.totalRecords = response.data.total_records;
            this.rows = response.data.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;

          });
    },

  },
  mounted() {
    this.loadItems();
    this.$cargarClasificadores( (res)=>{
      this.clasificadores=res.data
    },()=>{});
  },
  validations: {
    model:{
      descripcion:{required}
    },

  },
};
</script>

<style>
.smalltable {
  font-size: 12px !important;
}

</style>
